import { useEffect, useState } from "react";

interface ApiInfo {
  name: string;
  version: string;
}

export function Footer() {
  const [apiVersion, setApiVersion] = useState<string | null>(null);

  useEffect(() => {
    const apiUrl = import.meta.env.PROD
      ? "https://api.wooflit.com"
      : "https://api-staging.wooflit.com";

    fetch(apiUrl)
      .then((res) => res.json())
      .then((data: ApiInfo) => setApiVersion(data.version))
      .catch(() => setApiVersion("unavailable"));
  }, []);

  const buildDate = new Date(__BUILD_TIME__).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-gray-100 border-t border-gray-200 py-2 px-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center text-xs text-gray-500">
        <div className="flex gap-4">
          <span>web: {__GIT_SHA__}</span>
          <span>api: {apiVersion ?? "loading..."}</span>
        </div>
        <div>{buildDate}</div>
      </div>
    </footer>
  );
}
